
      import { analyticsUrl } from './src/ts/adobe-analytics/index.ts';
      const script = document.createElement('script');
      script.src = analyticsUrl;
      script.async = true;
      script.onerror = function() {
        console.error('Failed to load the analytics script');
      };
      document.head.appendChild(script);
    